import React from "react";

import "./everyDayLowPrice.scss";
import { EDLPImage } from "../../eCommerce.types";

type Props = {
    image?: EDLPImage;
};

const EveryDayLowPrice = ({ image }: Props) => {
    return (
        <div className="row mb-2">
            {image && (
                <img
                    className="every-day-low-price__img"
                    src={image.path}
                    alt={image.altText}
                />
            )}
        </div>
    );
};

export default EveryDayLowPrice;
